/* ============================================================
   MAHAFOOD — Product Card JS
   Datei: assets/mahafood-product-card.js
   ============================================================ */
 
function mfGetWishlist() {
  try { return JSON.parse(localStorage.getItem('mf_wishlist') || '[]'); }
  catch(e) { return []; }
}
 
function mfSaveWishlist(list) {
  localStorage.setItem('mf_wishlist', JSON.stringify(list));
}
 
function mfToggleWishlist(btn, productHandle) {
  var wishlist = JSON.parse(localStorage.getItem('mf_wishlist') || '[]');
  var index = wishlist.indexOf(productHandle);
 
  if (index === -1) {
    wishlist.push(productHandle);
    btn.classList.add('is-active');
  } else {
    wishlist.splice(index, 1);
    btn.classList.remove('is-active');
  }
 
  localStorage.setItem('mf_wishlist', JSON.stringify(wishlist));
 
  if (typeof mfUpdateWishlistCounter === 'function') {
    mfUpdateWishlistCounter();
  }
}
 
function mfUpdateWishlistCounter() {
  var count = mfGetWishlist().length;
  var counters = document.querySelectorAll('[data-mf-wishlist-count]');
  counters.forEach(function(el) {
    el.textContent = count;
    el.style.display = count > 0 ? 'inline-flex' : 'none';
  });
}
 
document.addEventListener('DOMContentLoaded', function() {
  var list = mfGetWishlist();
  list.forEach(function(id) {
    var btn = document.querySelector('.mf-wishlist-btn[data-product-id="' + id + '"]');
    if (btn) {
      btn.classList.add('is-active');
      btn.setAttribute('aria-label', 'Von Merkliste entfernen');
    }
  });
  mfUpdateWishlistCounter();
});
 
function mfSelectVariant(chip, productId) {
  if (chip.classList.contains('is-oos')) return;
 
  var container = document.getElementById('mf-variants-' + productId);
  container.querySelectorAll('.mf-variant-chip').forEach(function(c) {
    c.classList.remove('is-active');
  });
  chip.classList.add('is-active');
 
  var price     = parseInt(chip.dataset.price);
  var compare   = parseInt(chip.dataset.comparePrice || 0);
  var unitPrice = chip.dataset.unitPrice;
  var unitMeas  = chip.dataset.unitPriceMeasurement;
  var priceBlock = document.getElementById('mf-price-' + productId);
  var unitEl     = document.getElementById('mf-unit-' + productId);
  var atcBtn     = document.getElementById('mf-atc-' + productId);
 
  var fmt = function(cents) {
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  };
 
  if (compare > price) {
    priceBlock.innerHTML = '<span class="mf-price--current">' + fmt(price) + '</span><span class="mf-price--compare">' + fmt(compare) + '</span>';
  } else {
    priceBlock.innerHTML = '<span class="mf-price--current no-discount">' + fmt(price) + '</span>';
  }
 
  if (unitPrice && unitMeas) {
    unitEl.textContent = fmt(parseInt(unitPrice)) + '/' + unitMeas;
  }
 
  atcBtn.dataset.variantId = chip.dataset.variantId;
}
 
function mfChangeQty(productId, delta) {
  var el = document.getElementById('mf-qty-' + productId);
  var v = parseInt(el.textContent) + delta;
  if (v < 1) v = 1;
  el.textContent = v;
}
 
function mfAddToCart(btn, productId) {
  var variantId    = btn.dataset.variantId;
  var pfandId      = btn.dataset.pfandId;
  var qtyEl        = document.getElementById('mf-qty-' + productId);
  var qty          = parseInt(qtyEl ? qtyEl.textContent : 1);
  var originalHTML = btn.innerHTML;
 
  btn.disabled = true;
  btn.innerHTML = 'Wird hinzugef\u00FCgt\u2026';
 
  var formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', qty);
  if (pfandId && pfandId !== '') {
    // Nur _pfand setzen — kein _pfand_variant_id damit gleiche Properties wie Produktseite
    // → Shopify merged Line Items und Mengenrabatt-Function zählt korrekt
    formData.append('properties[_pfand]', '25');
  }
 
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    body: formData
  })
  .then(function(res) {
    if (!res.ok) throw new Error('failed');
    if (pfandId && pfandId !== '') {
      var pfandForm = new FormData();
      pfandForm.append('id', pfandId);
      pfandForm.append('quantity', qty);
      pfandForm.append('properties[_parent_variant_id]', variantId);
      pfandForm.append('properties[_is_deposit]', 'true');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: pfandForm
      });
    }
    return fetch('/cart.js');
  })
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    btn.innerHTML = '\u2713 Hinzugef\u00FCgt!';
    btn.style.background = '#1a6b3c';
 
    /* ── Warenkorb-Zähler im Header aktualisieren ── */
    document.querySelectorAll('.header__cart-count-number').forEach(function(el) {
      el.textContent = cart.item_count;
    });
 
    /* ── Canopy Drawer refreshen und öffnen ── */
    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    }, 500);
 
    /* ── Button nach 2s zurücksetzen ── */
    setTimeout(function() {
      btn.innerHTML = originalHTML;
      btn.style.background = '';
      btn.disabled = false;
    }, 2000);
  })
  .catch(function() {
    btn.innerHTML = '\u26A0 Fehler';
    btn.style.background = '#e03030';
    setTimeout(function() {
      btn.innerHTML = originalHTML;
      btn.style.background = '';
      btn.disabled = false;
    }, 2500);
  });
}